import React from 'react';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../constants';
import { prettyKey } from '../helpers/formatters';

const PortInfo = ({ data, data: { port_details } }) => (
  <div className="data">
    <table className="table">
      <tbody>
        {['mdn', 'mdn_type', 'carrier', 'port_id', 'port_dir'].map((attr) => (
          <tr key={attr}>
            <td>{prettyKey(attr)}</td>
            <td>{String(data[attr])}</td>
          </tr>
        ))}
        {port_details &&
          [
            'authorized_by',
            'first_name',
            'last_name',
            'street',
            'city',
            'state',
            'zip_code',
            'account',
            'pin',
          ].map((attr) => (
            <tr key={attr}>
              <td>{prettyKey(attr)}</td>
              <td>{String(port_details[attr])}</td>
            </tr>
          ))}
        {['submitted_at', 'completed_at'].map((attr) => (
          <tr key={attr}>
            <td>{prettyKey(attr)}</td>
            <td>{data[attr] && moment(data[attr]).format(DATE_TIME_FORMAT)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default PortInfo;
